import { TbTableFilled } from "react-icons/tb";
import { PiHourglassMediumFill } from "react-icons/pi";
import { SiMicrostrategy } from "react-icons/si";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaChartLine } from "react-icons/fa6";
import { FaFire } from "react-icons/fa";
import { BsFillPeopleFill } from "react-icons/bs";
import { FaSackDollar } from "react-icons/fa6";

import "./Strategy.css";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";

function Strategy() {
  const navigate = useNavigate();

  return (
    <div>
      <Header />
      <div className="strategy">
        <section className="contact__main__section__one">
          <h1>Our Strategy</h1>
        </section>
        <section className="sustainability__main__section__two">
          <h1>
            Driving Sustainable Growth Through Strategic Investments in Marine
            and Energy Solutions
          </h1>
          <hr />
          <p>
            Focused on Nigeria and Africa, GuineGulf Energy is committed to
            developing cutting-edge infrastructure that enhances the efficiency
            of our comprehensive range of services. We strategically assess
            opportunities at various stages of the marine and energy value
            chain, prioritizing initiatives that deliver high returns while
            minimizing risks. Our goal is to create sustainable value and
            operational excellence for our clients and stakeholders.
          </p>
        </section>
        <section className="strategy__section__one">
          <div className="strategy__section__one__details__display">
            <div>
              <FaChartLine className="strategy__section__one__explore__icon" />
              <div>
                <h3>Expanding Marine Logistics and Energy Infrastructure</h3>
                <p>
                  At GuineGulf Energy, our strategy revolves around expanding
                  and optimizing our marine logistics services, energy
                  infrastructure, and related assets. With deep expertise in the
                  West African region, we focus on enhancing operational
                  efficiency through the development of state-of-the-art
                  facilities and services such as vessel handling, marine
                  supply, dredging equipment leasing, and waste management.
                </p>
              </div>
            </div>
            <div>
              <FaFire className="strategy__section__one__explore__icon" />
              <div>
                <h3>Commitment to Safety and Environmental Responsibility</h3>
                <p>
                  We prioritize the safety of our operations and the protection
                  of the environment. GuineGulf Energy is dedicated to
                  maintaining the highest standards of corporate social
                  responsibility, ensuring that our services—from marine
                  logistics to waste management—are conducted in a safe and
                  environmentally responsible manner. We aim to create lasting,
                  positive impacts for the communities and ecosystems we serve.
                </p>
              </div>
            </div>
            <div>
              <BsFillPeopleFill className="strategy__section__one__explore__icon" />
              <div>
                <h3>Building a World-Class Management Team</h3>
                <p>
                  GuineGulf Energy is committed to maintaining a highly skilled
                  and dynamic management team to drive our growth strategy. We
                  continually seek talented professionals to refresh and
                  strengthen our leadership, ensuring we have the expertise and
                  vision to meet the increasing demands of our marine logistics,
                  energy services, and other operations.
                </p>
              </div>
            </div>
            <div>
              <FaSackDollar className="strategy__section__one__explore__icon" />
              <div>
                <h3>To secure access to capital and financial liquidity</h3>
                <p>
                  Our experienced team excels in securing the capital and
                  financial resources needed to fuel our expansion. With a
                  strong track record in raising funds and structuring deals,
                  GuineGulf Energy is well-positioned to finance the growth of
                  our marine logistics and energy infrastructure, ensuring we
                  continue to deliver reliable, cost-effective services across
                  the region.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="glance__section__three">
          <h1>Learn more about GuineGulf Energy energy:</h1>
          <div className="glance__section__three__explore">
            <div
              onClick={() => {
                navigate("/about/glance");
              }}
            >
              <TbTableFilled className="glance__section__three__explore__icon" />
              <h1>GuineGulf Energy at a Glance</h1>
              <p>
                GuineGulf Energy is a leading provider of marine and energy
                solutions, dedicated to delivering innovative services across
                trading, logistics, and vessel operations, with a focus on
                sustainable growth and excellence.
              </p>
            </div>
            <div
              onClick={() => {
                navigate("/about/purpose");
              }}
            >
              <PiHourglassMediumFill className="glance__section__three__explore__icon" />
              <h1>Our Purpose</h1>
              <p>
                To create value by delivering reliable, efficient, and
                customized solutions across the marine and energy industries
                while fostering sustainable practices.
              </p>
            </div>
            <div
              onClick={() => {
                navigate("/about/strategy");
              }}
            >
              <SiMicrostrategy className="glance__section__three__explore__icon" />
              <h1>Our Strategy</h1>
              <p>
                Build a comprehensive portfolio of services, including trading,
                marine logistics, vessel handling, equipment leasing, and waste
                management, to support the evolving needs of clients in Nigeria
                and West Africa.
              </p>
            </div>
            <div
              onClick={() => {
                navigate("/operations");
              }}
            >
              <MdOutlineMiscellaneousServices className="glance__section__three__explore__icon" />
              <h1>Our Operations</h1>
              <p>
                Our leadership team combines diverse business expertise and
                extensive industry experience to drive operational excellence
                and innovation in all aspects of our services.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Strategy;
